import Vue from "vue";
import KnockOut from "knockout";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import XtraVisualHelper from "@Scripts/Common/XtraVisualHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Responsive from "@Scripts/Infrastructure/Responsive";
import SearchViewModel from "@Scripts/ViewModels/SearchViewModel";
import GoogleMapsHelper from "@Scripts/Infrastructure/GoogleMapsHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "WorkWithUs", "Newsletter", "InfoRequest", "Account"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.onLoad();
        this.setSearchHeader();
        this.setVisuals();
        this.setSmoothPage();
        this.setClickAnimation();
        this.bindSearchViewModel();
        Responsive.onResize();
        this.setOpenForm();
        this.setAnalytics();
        this.removePresentation();
        this.closePresentation();
        this.changeSlide();
        this.openNewsletterDialog();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static openNewsletterDialog() {
        let ctas = document.querySelectorAll(".is-newsletterdialog");
        for (const item of ctas) {
            item.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
            })
        }
    }

    private static onLoad() {
        const self = this;

        (<any>window).addEventListener("load", function () {
            $("body, .visuals .item").removeClass("preload");
            $(".visual-area .loader").addClass("hden");
            self.setFancybox();
        });

        $(".ga-event[data-ga-id=\"VisualLink\"]").on("click", function () {
            GTagHelper.sendEvent("click", "visual", $(this).attr("href"));
        });
    }

    private static bindSearchViewModel() {
        (<any>window).App.viewModels.searchtext = new SearchViewModel();
        KnockOut.applyBindings((<any>window).App.viewModels.searchtext, document.getElementById("SearchBox"));
    }

    private static setAnalytics() {
        $(".editor a").on("click", function () {
            GTagHelper.sendEvent("click", "link", $(this).attr("href"));
        });
        
        $(".ga-event[data-ga-id=\"PhoneHeader\"]").on("click", function () {
            GTagHelper.sendEvent("click", "phone", "header");
        });
        
        $(".ga-event[data-ga-id=\"PhoneFooter\"]").on("click", function () {
            GTagHelper.sendEvent("click", "phone", "footer");
        });

        $(".ga-event[data-ga-id=\"OpenNewsletterHeader\"]").on("click", function () {
            GTagHelper.sendEvent("click", "open_newsletter", "header");
        });

        $(".ga-event[data-ga-id=\"OpenNewsletterFooter\"]").on("click", function () {
            GTagHelper.sendEvent("click", "open_newsletter", "footer");
        });
    }

    private static setFancybox() {
        (<any>$('[data-fancybox]')).fancybox({
            fullScreen: false,
            thumbs: false,
            slideShow: false,
            iframe: {
                scrolling: "auto"
            },
            image: {
                protect: true
            }
        });

        $(".close-fancy").click(function () {
            (<any>parent).jQuery.fancybox.getInstance().close();
        });
    }

    private static setOpenForm() {
        var button = $(".open-form"),
            content = $(".form");

        button.click(function () {
            content.slideToggle();
            button.toggleClass("active");
        });
    }

    private static setVisuals() {
        XtraVisualHelper.init();

        (<any>window).$(".visual-area").xtraVisual({
            timerInterval: 8000,
            isVisualLoaderEnabled: true,
            isSelectorEnabled: false,
            isTimerEnabled: true,
            isImageBackground: true,
            isSkinBackground: false,
            isSkinFullScreen: false,
            isGesture: true,
            onInit: this.onInit,
            onEnter: this.onEnter,
            onExit: this.onExit,
            isNavGesture: true
        });
    }

    private static onInit($visualSelected) {
        var $image = $(".image", $visualSelected),
            $title = $(".title", $visualSelected),
            $abstract = $(".abstract", $visualSelected),
            $calltoaction = $(".calltoaction", $visualSelected);

        // Clear previous styles added by velocity
        $image.removeClass("animate");
        $title.hide();
        $abstract.hide();
        $calltoaction.hide();
    }

    private static onEnter($visualSelected) {
        var defer = $.Deferred();

        var $image = $(".image", $visualSelected);
        var $title = $(".title", $visualSelected);
        var $abstract = $(".abstract", $visualSelected);
        var $calltoaction = $(".calltoaction", $visualSelected);

        // Stop all animations
        (<any>$image).velocity("stop");
        (<any>$title).velocity("stop");
        (<any>$abstract).velocity("stop");
        (<any>$calltoaction).velocity("stop");

        $image.addClass("animate");

        (<any>$title).velocity("transition.slideLeftIn", {
            delay: 300
        });

        (<any>$abstract).velocity("transition.slideRightIn", {
            delay: 300
        });

        (<any>$calltoaction).velocity("transition.slideLeftIn", {
            delay: 300,
            complete: function () {
                defer.resolve();
            }
        });

        return defer.promise();
    }

    private static onExit($visualSelected) {
        var defer = $.Deferred();

        var $image = $(".image", $visualSelected);
        var $title = $(".title", $visualSelected);
        var $abstract = $(".abstract", $visualSelected);
        var $calltoaction = $(".calltoaction", $visualSelected);

        // Stop all animations
        (<any>$image).velocity("stop");
        (<any>$title).velocity("stop");
        (<any>$abstract).velocity("stop");
        (<any>$calltoaction).velocity("stop");

        $image.removeClass("animate");

        (<any>$title.removeClass("animate")).velocity("transition.fadeOut");

        (<any>$abstract).velocity("transition.fadeOut", { delay: 0 });

        (<any>$calltoaction).velocity("transition.fadeOut", {
            delay: 0,
            complete: function () {
                defer.resolve();
            }
        });

        return defer.promise();
    }

    private static setSearchHeader() {
        $(".search-button .button.search").unbind().bind("click", function () {
            var delay = 0,
                delayhden = 100;

            $(".main-menu > .list-item > .item").each(function () {
                var $item = $(this);
                $(".submenu").slideUp();
                $(".submenu .exp").slideUp().removeClass("show");
                $(".search-button .button.search").fadeOut();
                setTimeout(function () {
                    $item.attr("data-search", "active");
                }, delay += 50);

                setTimeout(function () {
                    $(".main-menu .item").removeClass("show");
                    $item.addClass("hden");
                    $(".main-menu").addClass("hden");
                    $(".search-button .button.close").fadeIn();
                }, 450);
            });

            setTimeout(function () {
                $(".app-search").fadeIn().attr("data-search", "active");
                $("input.textbox")[0].focus();
                $(".app-suggestions").fadeIn();
            }, 450);
        });

        $(".search-button .button.close").unbind().bind("click", function () {
            var delay = 50;

            $(".submenu").show();
            $(".search-button .button.close").fadeOut();
            $(".app-suggestions").fadeOut();
            $(".app-search").fadeOut().removeAttr("data-search");
            setTimeout(function () {
                $(".search-button .button.search").fadeIn();
                $(".main-menu > .list-item > .item, .main-menu").removeClass("hden");
                $(".main-menu > .list-item > .item").each(function () {
                    var $item = $(this);
                    setTimeout(function () {
                        $item.removeAttr("data-search");
                    }, delay += 50);
                });
            }, 450);
        });
    }

    private static setGeoaddress() {
        $(".geoaddress a").attr("href", function () {
            var url = "maps://?q=";

            if (Responsive.device.OS.isWindowsOS()) {
                url = "bingmaps:?q=";
            }

            if (Responsive.device.OS.isAndroid()) {
                url = "geo:?q=";
            }

            return url + $(this).attr("data-geourl");
        });
    }

    private static setGoogleMaps() {
        GoogleMapsHelper.set();
    }

    private static setSmoothPage() {
        $("a[href*=\\#]:not([href=\\#])").click(function () {
            if (location.pathname.replace(/^\//, "") === (<any>this).pathname.replace(/^\//, "") && location.hostname === (<any>this).hostname) {
                var target = $((<any>this).hash);
                target = target.length ? target : $("[name=" + (<any>this).hash.slice(1) + "]");
                if (target.length) {
                    $("html,body").animate({
                        scrollTop: target.offset().top - 45
                    }, 1000);
                    return false;
                }
            }
            return false;
        });
    }

    private static setClickAnimation() {
        $(function () {
            var ink, d, x, y;
            $(".click-fx").click(function (event) {
                if ($(this).find(".ink").length === 0) {
                    $(this).prepend("<span class='ink'></span>");
                }

                ink = $(this).find(".ink");
                ink.removeClass("ink-animate");

                if (!ink.height() && !ink.width()) {
                    d = Math.max($(this).outerWidth(), $(this).outerHeight());
                    ink.css({ height: d, width: d });
                }

                x = event.pageX - $(this).offset().left - ink.width() * 0.5;
                y = event.pageY - $(this).offset().top - ink.height() * 0.5;

                ink.css({ top: y + "px", left: x + "px" }).addClass("ink-animate");
            });
        });
    }

    private static setMenu(category) {
        $(".main-menu .list-item .item[data-type = " + category + "]").attr("data-selected", "true");
    }

    private static removePresentation() {
        $("#remove-presentation").click(async function () {
            let slideId = this.getAttribute("data-slide");
            let presentationId = this.getAttribute("data-presentation");

            const result = (await Axios.post((<any>window).App.routes.Presentation_EndPresentation, { presentationId: presentationId, slideId: slideId })).data;
            window.location.href = result.redirectUrl;
        });
    }

    private static closePresentation() {
        $("#close-presentation").click(async function () {
            let slideId = this.getAttribute("data-slide");
            let presentationId = this.getAttribute("data-presentation");

            const result = (await Axios.post((<any>window).App.routes.Presentation_EndPresentation, { presentationId: presentationId, slideId: slideId })).data;
            location.reload();
        });
    }

    private static changeSlide() {
        $(".change-slide").click(async function () {
            let slideId = this.getAttribute("data-slide");
            let presentationId = this.getAttribute("data-presentation");

            const result = (await Axios.post((<any>window).App.routes.Presentation_ChangeSlide, { presentationId: presentationId, slideId: slideId })).data;
            window.location.href = result.redirectUrl;
        });
    }
}